<template>
  <textarea
    v-model="modelValue"
    :rows="rows"
    data-slot="textarea"
    :class="
      cn(
        'tw:border-input-border tw:placeholder:text-placeholder tw:placeholder:font-medium tw:focus-visible:border-focus-border tw:focus-visible:ring-3 tw:focus-visible:ring-ring/25 tw:aria-invalid:ring-destructive/20 tw:aria-invalid:border-destructive tw:block tw:w-full tw:resize-none tw:rounded-control tw:border-[1.5px] tw:bg-input-surface tw:focus:bg-card tw:px-[16px] tw:py-[13px] tw:type-textarea tw:min-w-0 tw:transition-[color,box-shadow] tw:outline-none tw:disabled:cursor-not-allowed tw:disabled:opacity-50',
        props.class,
      )
    "
  />
</template>

<script setup>
defineOptions({ name: 'UiTextarea' });
import { useVModel } from '@vueuse/core';
import { cn } from '@/shared/utilities/classes';

const props = defineProps({
  class: {
    default: undefined,
    type: [Boolean, null, String, Object, Array],
    required: false,
    skipCheck: true,
  },
  defaultValue: { default: undefined, type: [String, Number], required: false },
  modelValue: { default: undefined, type: [String, Number], required: false },
  rows: { default: 3, type: [String, Number] },
});

const emits = defineEmits(['update:modelValue']);

const modelValue = useVModel(props, 'modelValue', emits, {
  passive: true,
  defaultValue: props.defaultValue,
});
</script>
